import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const MachineLearningJumbotron = () => {
  return (
    <section data-cy="science-and-research-blurb" className="md:pt-16 xl:pb-8">
      <LandingPageJumbotron
        description="science_and_research_ai_learn_description"
        title="science_and_research_ai_learn_title"
      />
    </section>
  );
};

export default MachineLearningJumbotron;
